import { DiaryReportService } from 'src/app/services/diary-report.service';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../models/user';
import { LoginService } from '../services/login.service';
import { NgForm } from '@angular/forms';
import { MasterDataService } from '../services/master-data.service';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { WarningBoxComponent } from '../human-resource/warning-box/warning-box.component';
import { MydiaryService } from 'src/app/services/mydiary.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TravelSheetService } from '../services/travel-sheet.service';
import { AssetsManagementService } from '../services/assets-management.service';
import Swal from 'sweetalert2';
import { CommonMessageService } from '../services/common-message.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  user = new User('', '');
  userProfile: any;
  forgotPasswordForm;
  submitted = false;
  email;
  constructor(
    public dialog: MatDialog,
    public router: Router,
    private loginService: LoginService,
    private masterDataService: MasterDataService,
    private mydiaryService: MydiaryService,
    private organizationSetupService: OrganizationSetupService,
    private humanResourceService: HumanResourceService,
    private diaryReportService: DiaryReportService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private travelSheetService: TravelSheetService,
    private assetsManagementService: AssetsManagementService,
    private commonMessageService: CommonMessageService
  ) { }

  ngOnInit(): void {
    this.initModalForm();
  }

  onLoginClick(myForm: NgForm) {
    if (myForm.form.invalid) {
    } else {
      this.loginService.login(JSON.stringify(this.user)).subscribe((resp) => {
        console.log('loginresp', resp);
        console.log('resp.headers', resp.headers);
        console.log('resp.headers', resp.headers.get(''));
        // console.log(resp.headers.get('authorization'));
        if (resp.headers.get('authorization')) {
          localStorage.setItem('token', resp.headers.get('authorization'));
          localStorage.setItem('userid', resp.headers.get('userid'));
          //localStorage.setItem('droles', resp.)
          this.mydiaryService.refreshHttpOptions();
          this.masterDataService.refreshHttpOptions();
          this.organizationSetupService.refreshHttpOptions();
          this.humanResourceService.refreshHttpOptions();
          this.diaryReportService.refreshHttpOptions();
          this.travelSheetService.refreshHttpOptions();
          this.assetsManagementService.refreshHttpOptions();
          this.loadUserDetails(
            resp.headers.get('userid'),
            resp.headers.get('authorization')
          );

        }
      });
    }
  }

  pendingTransferRequest;
  reason;
  getAssetPendingRequestList() {
    this.assetsManagementService.getHardwarePendingRequest().subscribe((resp: any) => {
      this.pendingTransferRequest = resp;
      console.log('pending transfer request', this.pendingTransferRequest);
      this.pendingTransferRequest.map((data => {
        if (data.toUser.id == this.userId && data.status == 'Pending') {
          console.log('pending transfer data', data);
          var textValue = data.requestBy.firstName + " " + data.requestBy.lastName + " has transfered the " + data.asset.subType.name + " " + data.asset.serviceTagNumber + " to you. please accept/reject this transfer.";

          // if (data.fromUser != null) {
          //   var textValue = data.fromUser.firstName + " " + data.fromUser.lastName + " has transfered the asset " + data.asset.serviceTagNumber + " to you. please accept/reject this transfer."
          // } else {
          //   var textValue = data.requestBy.firstName + " " + data.requestBy.lastName + " has transfered the asset " + data.asset.serviceTagNumber + " to you. please accept/reject this transfer.";
          // }
          Swal.fire({
            // title: 'Are you sure?',
            text: textValue,
            showCancelButton: true,
            confirmButtonColor: '#800000',
            cancelButtonColor: '#FF2F2F',
            confirmButtonText: 'Accept',
            cancelButtonText: 'Reject',
            allowOutsideClick: false,
          }).then((result) => {
            console.log('swal result', result);
            if (result.isConfirmed) {
              console.log('confirm')
              this.assetsManagementService.approveTransferRequest(data.id, 'Approved', this.reason).subscribe((resp: any) => {
                //  this.commonMessageService.acceptMessage();
                this.commonMessageService.swalAlertWithoutIcon('', 'Accept Successfully');
                localStorage.setItem('isAssetConfirm', 'true');
              });
            }
            else if (result.isDismissed) {
              Swal.fire({
                text: 'Enter Reason',
                confirmButtonColor: '#800000',
                input: 'text',
                allowOutsideClick: false,
              }).then((result) => {
                console.log('swal inout value', result);
                this.reason = result.value;
                this.assetsManagementService.approveTransferRequest(data.id, 'Declined', this.reason).subscribe((resp: any) => {
                  // this.commonMessageService.acceptMessage();
                  localStorage.setItem('isAssetConfirm', 'true');
                });
              })

            }
          })
        } else if (data.fromUser != null) {
          if (data.fromUser.id == this.userId && data.status == 'Pending') {
            var msgValue = "The " + data.asset.subType.name + " with " + data.asset.serviceTagNumber + " has been auto assigned from " + data.requestBy.firstName + " " + data.requestBy.lastName + " to " + data.toUser.firstName + " " + data.toUser.lastName;
            Swal.fire({
              // title: 'Are you sure?',
              text: msgValue,
              // showCancelButton: true,
              confirmButtonColor: '#800000',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
              // cancelButtonText: 'Reject',
              allowOutsideClick: false,
            }).then((result) => {
              console.log('swal result', result);
            })
          }
        }
      }))

    });
  }

  test() {
    console.log('hii......niukhil');
  }
  warningBox() {
    this.dialog.open(WarningBoxComponent);
  }

  userId;
  loadUserDetails(userid, token) {
    this.masterDataService
      .getUserProfileById(userid, token)
      .subscribe((res) => {
        console.log('resdetails', res);
        this.userProfile = res;
        this.userId = this.userProfile.id;
        // this.monthlyAssetPopup();
        localStorage.setItem('userFname', this.userProfile.firstName);
        localStorage.setItem('userLname', this.userProfile.lastName);
        localStorage.setItem('userMname', this.userProfile.middleName);
        if (this.userProfile.designation != null) {
          localStorage.setItem('userDesignation', this.userProfile.designation.name);
        }
        console.log('user oficial details', this.userProfile.userOfficialDetails);
        if (this.userProfile.userOfficialDetails != null || this.userProfile.userOfficialDetails.icaiRegistrationDate) {
          localStorage.setItem('userICAIRegistrationDate', this.userProfile.userOfficialDetails.icaiRegistrationDate);
        }

        if (this.userProfile.userDocStatus == 'Pending') {
          this.warningBox();
        }
        var myRoleSetStatus = false
        for (let i = 0; i < this.userProfile.droles.length; i++) {
          console.log("login user role", this.userProfile.droles[i].name)
          localStorage.setItem('userRole', this.userProfile.droles[i].name);
          localStorage.setItem('userRoleId', this.userProfile.droles[i].id);
          console.log(myRoleSetStatus)
          if (this.userProfile.droles[i].name == 'Partner') {
            console.log("in partner")
            localStorage.setItem('droles', this.userProfile.droles[i].name);
            myRoleSetStatus = true
          }
        }
        if (!myRoleSetStatus) {
          localStorage.setItem('droles', 'myrole');
        }

        for (let i = 0; i < this.userProfile.droles.length; i++) {
          if (this.userProfile.droles[i].name == "Partner") {
            localStorage.setItem('announcementRoles', this.userProfile.droles[i].name);
          } else if (this.userProfile.droles[i].name == "HR Executive" ||
            this.userProfile.droles[i].name == "HR Assistant" ||
            this.userProfile.droles[i].name == "HR Manager") {
            localStorage.setItem('announcementRoles', 'HR');
          } else {
            localStorage.setItem('announcementRoles', 'droles');
          }
        }

        console.log("Announcement Roles", localStorage.getItem('announcementRoles'));

        // var droles=[];
        // localStorage.setItem('droles',this.userProfile.droles);
        console.log('myuser droles', localStorage.getItem('droles'));
        localStorage.setItem('userType', this.userProfile.type);
        localStorage.setItem('userDocStatus', this.userProfile.userDocStatus);

        localStorage.setItem('id', this.userProfile.id);
        if (this.userProfile.userOfficialDetails) {
          localStorage.setItem(
            'branchId',
            this.userProfile.userOfficialDetails.branch.id
          );
          localStorage.setItem(
            'branchName',
            this.userProfile.userOfficialDetails.branch.name
          );

          for (let i = 0; i < this.userProfile.userOfficialDetails.serviceVerticle.length; i++) {
            const item = this.userProfile.userOfficialDetails.serviceVerticle[i];

            localStorage.setItem(
              'serviceVerticalId',
              item.userServiceVerticle.id
            );

            localStorage.setItem(
              'serviceVertical',
              item.userServiceVerticle.name
            );
          }

        }
        if (this.userProfile.userOfficialDetails) {
          localStorage.setItem('partnerArray', JSON.stringify(this.userProfile.userOfficialDetails.reportingPartners));

          if (
            this.userProfile.userOfficialDetails.reportingPartners.length > 1
          ) {
            this.userProfile.userOfficialDetails.reportingPartners.forEach(
              (element) => {
                var startDate = new Date(element.startDate);
                var endDate = new Date(element.endDate);
                // var currentDate = new Date();
                var currentDate = moment(new Date()).format('YYYY-MM-DD');
                console.log(startDate, endDate);
                console.log(currentDate);
                if (
                  currentDate >= element.startDate &&
                  currentDate <= element.endDate
                ) {
                  localStorage.setItem(
                    'reportingPartnerId',
                    element.reportingPartner.id
                  );
                  var partnerName = element.reportingPartner.firstName + ' ' + element.reportingPartner.lastName;
                  localStorage.setItem('reportingPartnerName', partnerName);
                }
              }
            );
          } else {
            if (
              this.userProfile.userOfficialDetails.reportingPartners.length == 1
            ) {
              localStorage.setItem(
                'reportingPartnerId',
                this.userProfile.userOfficialDetails.reportingPartners[0]
                  .reportingPartner.id
              );
            }
          }

        }
        this.router.navigateByUrl('dashboard');
      });
  }


  monthlyAssetPopup() {
    var currentDate = new Date();
    console.log("currentDate", currentDate.getDate())
    if (currentDate.getDate() == 24) {
      Swal.fire({
        // title: 'Are you sure?',
        text: "Please take periodic backups and sync your one drive folders.",
        // showCancelButton: true,
        confirmButtonColor: '#800000',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        // cancelButtonText: 'Reject',
        allowOutsideClick: false,
        allowEnterKey: false,

      }).then((result) => {
        console.log('swal result', result);
        Swal.close();
      })
    } else if (currentDate.getDate() == 10) {
      Swal.fire({
        text: "Make sure your anti-virus is updated.",
        confirmButtonColor: '#800000',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
      }).then((result) => {
        console.log('swal result', result);
      })
    } else if (currentDate.getDate() == 15) {
      Swal.fire({
        text: "Please Tune up the QH anti-virus regularly.",
        confirmButtonColor: '#800000',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
      }).then((result) => {
        console.log('swal result', result);
      })
    } else if (currentDate.getDate() == 25) {
      Swal.fire({
        text: "Do the Windows updates regularly and make sure to restart the Laptop every day, for the updates to configure properly.",
        confirmButtonColor: '#800000',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
      }).then((result) => {
        console.log('swal result', result);
      })
    }
  }

  //forget Password
  initModalForm() {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
    });
  }

  onModalClick(modalContent) {
    this.openModal(modalContent);
  }

  openModal(content) {
    this.submitted = false;
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(content, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  onSaveClick() {
    this.submitted = true;
    if (this.forgotPasswordForm.valid) {
      this.email = this.forgotPasswordForm.controls['email'].value;

      this.masterDataService.getForgotPassword(this.email).subscribe((res) => {
        console.log('forget password response', res.operationResult);
        if (res.operationResult == "please enter valid mailId") {
          this.commonMessageService.swalAlertWithoutIcon('', "Please enter mail which exist in your system.");
        } else if (res.operationResult == "verification link sent to your mailId") {
          this.commonMessageService.swalAlertWithoutIcon('', "please check your mail for new password.");
          this.closeModel();
        }
      });
    }
  }

  closeModel() {
    this.forgotPasswordForm.reset();
    this.modalService.dismissAll();
  }
}

// Local Storage Code Snippet
// General syntax for storing data
// localStorage.setItem('key', 'value');

// And if you have an object that you want to save, stringify it like this
// localStorage.setItem('some-key', JSON.stringify(itemData));

// OR for individual key-value pairs
// localStorage.setItem('some-key', JSON.stringify({ token: token, name: name }));

// To retrieve data from localstorage
// const myData = JSON.parse(localStorage.getItem('some-key'));

// To remove a value/item from localStorage
// localStorage.removeItem("some-key");
